export default __webpack_public_path__ + "static/media/add_services04.30413fd7.webp";